import { getCookie } from "./cookie";
import { inBrowser } from "./env";

/**
 * Staff mode: a browser our own people work in — telesales making quotes for
 * customers on the website — and which the website does not count as a
 * visitor.
 *
 * Turned on by opening any page with `?lassie_staff=1`, off with
 * `?lassie_staff=0`. The cookie is written back on every visit, so it runs out
 * only after a year without one.
 *
 * In staff mode nothing reaches Amplitude or Google Tag Manager.
 *
 * All it does is opt out, so anyone may set it.
 */
export const STAFF_COOKIE = "lassie_staff";
export const STAFF_PARAM = "lassie_staff";

export const staffCookie = {
  name: STAFF_COOKIE,
  value: "1",
  path: "/",
  maxAge: 60 * 60 * 24 * 365,
};

/**
 * Whether a request comes from staff. The URL wins over the cookie, so the
 * request that turns staff mode on or off already counts as such — the cookie
 * it sets only arrives with the next one.
 */
export const isStaff = ({
  param,
  cookie,
}: {
  param: string | null | undefined;
  cookie: string | null | undefined;
}): boolean =>
  param === "1" || param === "0" ? param === "1" : cookie === "1";

export const isStaffBrowser = (): boolean =>
  inBrowser && getCookie(STAFF_COOKIE) === "1";
